import { useStore } from 'vuex';
import { computed } from 'vue';
import { IPageParams } from '@types/definitions'; // eslint-disable-line no-unused-vars

/**
 * Use page parameters from the Server.
 *
 * @returns {IPageParams} - static object with page params from the server.
 */
export default function usePageData() {
  const store = useStore();
  return computed(() => store?.getters?.getPage);
}
